module.exports = __webpack_public_path__ + "static/media/4ODA6.ba49fb67.jpg";